<template>
  <div>
    <span v-text="header.text" />
    <BInfo
      v-if="header.hint"
      icon="mdi-message-alert-outline"
      icon-class="ml-1"
      :text="header.hint"
      size="1rem"
    />
  </div>
</template>

<script>
import BInfo from '@/components/common/BInfo.vue'


export default {
  name: 'LKPublicationsFormdataTableHeader',
  components: {
    BInfo,
  },
  props: {
    header: {
      type: Object,
    },
  },
  computed: {
    info() {
      return this.header.info
    },
  },
}
</script>
